import notificationsApi from '@/api/v1/notifications';

export default {
  namespaced: true,
  state: {
    notifications: [],
    unreadNotificationsCount: 0,
  },

  mutations: {
    SET_NOTIFICATIONS(state, notifications) {
      state.notifications = notifications;
    },

    SET_NOTIFICATION_STATUS(state, id) {
       const index = state.notifications.findIndex((note) => note.id === id);
       state.notifications[index].seen = !state.notifications[index].seen;
    },

    SET_ALL_NOTIFICATIONS_STATUSES(state) {
      state.notifications = state.notifications.map((note) => ({
          ...note,
          seen: true,
        }));
      state.unreadNotificationsCount = 0;
    },

    UPDATE_UNREAD_COUNT(state, value) {
      if (value) {
        state.unreadNotificationsCount += 1;
      } else if (state.unreadNotificationsCount > 0) {
        state.unreadNotificationsCount -= 1;
      }
    },

    GET_UNREAD_NOTIFICATIONS_COUNT(state, unread) {
      state.unreadNotificationsCount = unread;
    },

  },

  actions: {
    fetchNotifications({ commit, dispatch, rootState }) {
      commit('CHANGE_LOADING_STATUS', true, { root: true });

      const { selectedFilters } = rootState.filters;
      const { itemsPerPage, pagination } = rootState.pagination;
      const params = {
        page: pagination.page,
        itemsPerPage,
        filters: selectedFilters,
      };
      notificationsApi.index(params)
        .then((response) => {
          commit('SET_NOTIFICATIONS', response.data.collection);
          dispatch('pagination/setPagination', response.data.pagination, { root: true });
        })
        .finally(() => {
          commit('CHANGE_LOADING_STATUS', false, { root: true });
        });
    },

    changeSingleNotificationStatus({ commit }, notification) {
      commit('CHANGE_LOADING_STATUS', true, { root: true });
      const { id, seen } = notification;
      notificationsApi.update(id, !seen)
        .then(() => {
          commit('UPDATE_UNREAD_COUNT', seen);
          commit('SET_NOTIFICATION_STATUS', id);
        })
        .finally(() => {
          commit('CHANGE_LOADING_STATUS', false, { root: true });
        });
    },

    changeAllNotificationsStatus({ commit }) {
      commit('CHANGE_LOADING_STATUS', true, { root: true });

      notificationsApi.updateAll()
        .then(() => {
          commit('SET_ALL_NOTIFICATIONS_STATUSES');
        })
        .finally(() => {
          commit('CHANGE_LOADING_STATUS', false, { root: true });
        });
    },

    incrementUnread({ commit }) {
      commit('UPDATE_UNREAD_COUNT', true);
    },

    getUnreadNotificationsCount({ commit }) {
      notificationsApi.unreadNotificationsCount()
        .then((resp) => {
          commit('GET_UNREAD_NOTIFICATIONS_COUNT', resp.data.unseenCount);
        });
    },

  },
};
